class HorizontalScrollGSAP {
  constructor(sectionId) {
    this.section = document.querySelector(`[data-section="${sectionId}"]`);
    if (!this.section) return;
    
    this.container = this.section.querySelector('.horizontal-container');
    this.scrollContent = this.section.querySelector('.horizontal-scroll__container');
    this.slides = this.section.querySelectorAll('.horizontal-scroll__slide');
    this.slideCount = this.slides.length;
    
    this.init();
  }
  
  init() {
    if (this.slideCount <= 1 || window.innerWidth < 1024) return;
    
    this.calculateDimensions();
    this.initScrollTrigger();
    this.bindEvents();
  }
  
  calculateDimensions() {
    const slideWidth = this.slides[0].offsetWidth;
    const gap = 48; // lg:gap-12 对应 3rem = 48px
    this.slideTotalWidth = slideWidth + gap;
    this.totalWidth = this.slideTotalWidth * this.slideCount - gap; // 减去最后一个slide的gap
    
    gsap.set(this.scrollContent, {
      width: this.totalWidth,
      x: 0
    });
  }
  
  initScrollTrigger() {
    // 清理现有的ScrollTrigger
    ScrollTrigger.getAll().forEach(st => st.kill());
    
    // 计算可滚动距离
    const scrollDistance = this.totalWidth - window.innerWidth;
    
    // 确保滚动距离为正数
    if (scrollDistance <= 0) return;
    
    // 创建pin效果
    ScrollTrigger.create({
      trigger: this.container,
      start: 'top top',
      end: `+=${scrollDistance}`,
      pin: true,
      pinSpacing: true,
      anticipatePin: 1,
      invalidateOnRefresh: true
    });
    
    // 创建水平滚动动画
    gsap.to(this.scrollContent, {
      x: -scrollDistance,
      ease: 'none',
      scrollTrigger: {
        trigger: this.container,
        start: 'top top',
        end: `+=${scrollDistance}`,
        scrub: 1,
        invalidateOnRefresh: true
      }
    });
    
    // 刷新ScrollTrigger
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);
  }
  
  bindEvents() {
    window.addEventListener('resize', this.debounce(() => {
      if (window.innerWidth >= 1024) {
        this.calculateDimensions();
        this.initScrollTrigger();
      } else {
        // 移动端时清理ScrollTrigger并重置样式
        ScrollTrigger.getAll().forEach(st => st.kill());
        gsap.set(this.scrollContent, { clearProps: 'all' });
        gsap.set(this.container, { clearProps: 'all' });
      }
    }, 250));
  }
  
  debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') {
    console.error('GSAP not loaded');
    return;
  }
  
  // 注册ScrollTrigger插件
  gsap.registerPlugin(ScrollTrigger);
  
  // 设置ScrollTrigger默认值
  ScrollTrigger.defaults({
    toggleActions: 'play pause resume reset'
  });
  
  // 初始化所有horizontal scroll section
  document.querySelectorAll('[data-section-id]').forEach(section => {
    const sectionId = section.dataset.sectionId;
    new HorizontalScrollGSAP(sectionId);
  });
});

// 处理Shopify动态加载的section
document.addEventListener('shopify:section:load', (event) => {
  if (typeof gsap === 'undefined') return;
  
  const sectionId = event.detail.sectionId;
  setTimeout(() => {
    new HorizontalScrollGSAP(sectionId);
  }, 100);
});

// 清理资源
document.addEventListener('shopify:section:unload', () => {
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.getAll().forEach(st => st.kill());
  }
});

// 页面完全加载后刷新
window.addEventListener('load', () => {
  if (typeof ScrollTrigger !== 'undefined') {
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 200);
  }
});